// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"zN-z","carouselContainer":"AN-z"};